var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.625,
    height: 31.625,
    x: 0.688,
    y: 0.688,
    fill: "#1F72CD",
    stroke: "#D6DCE9",
    strokeWidth: 1.375,
    rx: 4.813
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.163 11.688 4.8 21.651h5.223l.647-1.589h1.48l.648 1.589h5.748v-1.213l.513 1.213h2.973l.513-1.238v1.238H34.5l1.453-1.548 1.361 1.548 6.141.013-4.376-4.967 4.376-5.01h-6.045l-1.415 1.518-1.319-1.518H21.671l-1.117 2.571-1.143-2.572h-5.212v1.172l-.58-1.171H9.163Zm17.853 1.415h6.866l2.1 2.34 2.167-2.34h2.1l-3.19 3.593 3.19 3.553h-2.195l-2.1-2.369-2.178 2.369h-6.76v-7.146Zm1.696 2.785v-1.306h4.284l1.869 2.087-1.952 2.098h-4.201v-1.424h3.745v-1.455h-3.745Zm-18.539-2.785h2.546l2.894 6.757v-6.757h2.789l2.235 4.844 2.06-4.844h2.774v7.15h-1.688l-.014-5.603-2.461 5.603h-1.51l-2.476-5.603v5.603h-3.474l-.658-1.603H9.632l-.657 1.601H7.114l3.06-7.148Zm.067 4.065 1.172-2.855 1.17 2.855H10.24Z",
    clipRule: "evenodd"
  })));
};
export default SvgAmex;